export const customerContractPriceLists = {
  name: "Titel",
  startDate: "Startdatum",
  endDate: "Slutdatum",
  nothingFoundAddNew: "Lägg till ny prislista",
  customers: "Kunder",
  items: "Antal",
  empty: "Inga aktuella prislistor"
};
